import React, { useContext, useEffect, useState } from 'react'
import { NormasContext } from '../../context/NormasContext';
// ui
import { Accordion } from "react-bootstrap"
import { Oval } from 'react-loader-spinner'

const EditarSubtarea = ({ idTarea, handleEdit }) => {
    const [activeSubtaskKey, setActiveSubtaskKey] = useState(null);

    const { 
        status,
        subtareas,
        fetchSubtareas
    } = useContext(NormasContext)

    useEffect(() => {
        // 1. Aseguramos que la clave sea una cadena para la búsqueda consistente en el objeto subtareas
        const idTareaString = idTarea ? idTarea.toString() : null; 
        // 2. Solo cargamos si idTarea existe Y NO ESTÁ EN CACHÉ (la clave no existe en el objeto subtareas)
        // NOTA: Si subtareas[idTareaString] es [], es un array cargado y la condición falla (usa caché).
        if (idTareaString && subtareas[idTareaString] === undefined) {
            fetchSubtareas({
                idtarea: idTarea
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTarea])

    const handleSubtaskSelect = (eventKey) => {
        setActiveSubtaskKey(activeSubtaskKey === eventKey ? null : eventKey);
    };

    const data = subtareas[idTarea] || []

    const padres = data.filter(p => p.nivel_prioridad === 0)
    const getHijas = (idPadre) => data.filter(p => p.fk_subtarea_padre === idPadre)

    return (
        <div className='subtareas'>
            {status.subtareas.loading ? (
                <div className='loading__subtareas d-flex flex-row align-items-center justify-content-center'>
                    <Oval
                        visible={true}
                        height="40"
                        width="40"
                        color="#0d6efd"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <p className='m-0 fw-medium'>Loading...</p>
                </div>
            ) : (
                <>
                    {status.subtareas.error ? (
                        <div className='subtareas--error d-flex flex-column align-items-center'>
                            <p className='text-danger fw-medium'><i className="bi bi-exclamation-circle me-1"></i> {status.subtareas.error}</p>
                        </div>
                    ) : (
                        <>
                            {padres.length > 0 && (
                                <div className='subtareas__container'>
                                    {padres.map((padre) => {
                                        const hijas = getHijas(padre.id_subtarea_norma)
                                        const eventKeyString = padre.id_subtarea_norma.toString();

                                        if(hijas.length > 0){
                                            return (
                                                <Accordion 
                                                    key={padre.id_subtarea_norma} 
                                                    className='mb-3'
                                                    activeKey={activeSubtaskKey}
                                                    onSelect={handleSubtaskSelect}
                                                >
                                                    <Accordion.Item 
                                                        eventKey={eventKeyString}
                                                    >
                                                        <Accordion.Header>{padre.titulo}</Accordion.Header>
                                                        <Accordion.Body>
                                                            {/* Titulo de la subarea padre */}
                                                            <div className='d-flex flex-column'>
                                                                <div className='mb-2 d-flex flex-row align-items-center gap-4'>
                                                                    <h4 className='m-0 p-0 text-blue-500 fw-medium'>Título de la subsección</h4>
                                                                    <button 
                                                                        className='btnEditTextosNormas btn btn-sm btn-success rounded-pill px-3 fw-medium cursor-pointer ms-auto d-flex align-items-center justify-content-center'
                                                                        onClick={()=>handleEdit(padre.id_subtarea_norma, 3)}
                                                                    >Editar subsección</button>
                                                                </div>
                                                                <p>{padre.titulo}</p>
                                                            </div>
                                                            {/* Descripción de la subtarea padre */}
                                                            {padre.descripcion && (
                                                                <div className='d-flex flex-column'>
                                                                    <h4 className='m-0 p-0 mb-2 text-blue-500 fw-medium'>Descripción de la subsección</h4>
                                                                    <div className='texto-descripcion'>
                                                                        <p>{padre.descripcion}</p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div>
                                                                {hijas.map((hija) => (
                                                                    <div 
                                                                        key={hija.id_subtarea_norma} 
                                                                        className='subtareas__container__eachSub hijas p-3 rounded-3 border border-light-subtle'
                                                                    >
                                                                        {/* Titulo de la subarea hija */}
                                                                        <div className='d-flex flex-column'>
                                                                            <div className='mb-2 d-flex flex-row align-items-center gap-4'>
                                                                                <h4 className='m-0 p-0 text-blue-500 fw-medium'>Título de la subsección</h4>
                                                                                <button 
                                                                                    className='btnEditTextosNormas btn btn-sm btn-success rounded-pill px-3 fw-medium cursor-pointer ms-auto d-flex align-items-center justify-content-center'
                                                                                    onClick={()=>handleEdit(hija.id_subtarea_norma, 3)}
                                                                                >Editar subsección</button>
                                                                            </div>
                                                                            <p>{hija.titulo}</p>
                                                                        </div>
                                                                        {/* Descripción de la subtarea hija */}
                                                                        {hija.descripcion && (
                                                                            <div className='d-flex flex-column'>
                                                                                <h4 className='m-0 p-0 mb-2 text-blue-500 fw-medium'>Descripción de la subsección</h4>
                                                                                <div className='texto-descripcion'>
                                                                                    <p>{hija.descripcion}</p>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            )
                                        }

                                        return (
                                            <div key={padre.id_subtarea_norma} className="subtareas__container__eachSub padres p-3 rounded-3 border border-light-subtle">
                                                {/* Titulo de la subarea padre */}
                                                <div className='d-flex flex-column'>
                                                    <div className='mb-2 d-flex flex-row align-items-center gap-4'>
                                                        <h4 className='m-0 p-0 text-blue-500 fw-medium'>Título de la subsección</h4>
                                                        <button 
                                                            className='btnEditTextosNormas btn btn-sm btn-success rounded-pill px-3 fw-medium cursor-pointer ms-auto d-flex align-items-center justify-content-center'
                                                            onClick={()=>handleEdit(padre.id_subtarea_norma, 3)}
                                                        >Editar subsección</button>
                                                    </div>
                                                    <div className='texto-descripcion'>
                                                        <p>{padre.titulo}</p>
                                                    </div>
                                                </div>
                                                {/* Descripción de la subtarea padre */}
                                                {padre.descripcion && (
                                                    <div className='d-flex flex-column'>
                                                        <h4 className='m-0 p-0 mb-2 text-blue-500 fw-medium'>Descripción de la subsección</h4>
                                                        <div className='texto-descripcion'>
                                                            <p>{padre.descripcion}</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    )
}

export default EditarSubtarea